import I18n from 'I18n';
import { Select } from 'foundations-components/components/Select';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { FiltersWrapper } from '../../filters/components/FiltersWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const PRODUCT_LANG_KEYS = {
  MARKETING_HUB_TOOLS: 'learningCenter.product.MARKETING_HUB_TOOLS',
  SALES_HUB_TOOLS: 'learningCenter.product.SALES_HUB_TOOLS',
  SERVICE_HUB_TOOLS: 'learningCenter.product.SERVICE_HUB_TOOLS',
  SMART_CRM_HUB_TOOLS: 'learningCenter.product.SMART_CRM_HUB_TOOLS'
};
const getOptions = () => Object.entries(PRODUCT_LANG_KEYS).map(([value, langKey]) => ({
  text: I18n.text(langKey),
  value
}));
export const ProductFilter = ({
  appearsIn
}) => {
  const [products, setProducts] = useSearchParam(FILTER_TYPES.TOOLS);
  const handleProductChange = newProductValues => {
    var _ref;
    const added = newProductValues.find(newProduct => !products.includes(newProduct));
    const removed = products.find(oldProduct => !newProductValues.includes(oldProduct));
    UsageTracker.trackStandalone('Filter Interaction', {
      action: added ? 'filter-selected' : 'filter-deselected',
      value: (_ref = added !== null && added !== void 0 ? added : removed) !== null && _ref !== void 0 ? _ref : null,
      isDropdown: true,
      key: 'product-filter',
      appearsIn
    });
    setProducts(newProductValues);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": I18n.text('learningCenter.academyOnboarding.resources.productLabel'),
      clearable: true,
      menuInlineSize: 200,
      menuMaxBlockSize: 400,
      multi: true,
      onSelectedOptionChange: evt => {
        handleProductChange(evt.selectedValues);
      },
      options: getOptions(),
      selectedItemsPlaceholder: I18n.text('learningCenter.academyOnboarding.resources.productLabel'),
      selectedValues: products
    })
  });
};